module.exports = __webpack_public_path__ + "4e2fc2217a7bc505d35b6fe6e2a9ae37.MP3";